import { render, staticRenderFns } from "./TeamRegionOptions.vue?vue&type=template&id=538c49a6&scoped=true&"
import script from "./TeamRegionOptions.vue?vue&type=script&lang=js&"
export * from "./TeamRegionOptions.vue?vue&type=script&lang=js&"
import style0 from "./TeamRegionOptions.vue?vue&type=style&index=0&id=538c49a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c49a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538c49a6')) {
      api.createRecord('538c49a6', component.options)
    } else {
      api.reload('538c49a6', component.options)
    }
    module.hot.accept("./TeamRegionOptions.vue?vue&type=template&id=538c49a6&scoped=true&", function () {
      api.rerender('538c49a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamRegionOptions.vue"
export default component.exports